const INITIAL_STATE = {}

export default {
  namespace: 'error',
  state: INITIAL_STATE,
  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
  },
  effects: {},
}
